import { CSSProperties, PropsWithChildren } from 'react'
import { CuraButton } from '@rededor/cura-react'
import { appSettings } from '@/shared/consts/appSettings'
import { whatsAppMessages } from '@/shared/consts/whatsAppMesssages'
import { sendEventGTM } from '@/services/googleTagManager'
import { gtmEvents } from '@/shared/consts/gtmEvents'
import { sendEvent } from '@/services/mixPanelService'
import { hasDoraIntegrationId } from '@/utils/helpers/automatedDoraService'

interface Props extends PropsWithChildren {
  phoneNumber?: string
  message?: string
  style?: CSSProperties
}

const hasDoraIntegration = hasDoraIntegrationId()
const whatsAppMessage = hasDoraIntegration
  ? whatsAppMessages.doraMessage
  : whatsAppMessages.default

export const ButtonWhatsApp = ({
  children = 'CONTINUE POR WHATSAPP',
  message = whatsAppMessage,
  phoneNumber = appSettings.whatsAppNumber,
  style = { width: '100%' }
}: Props) => {
  const handleOnClick = () => {
    sendEventGTM(gtmEvents.CLICK_EXTERNAL_WHATSAPP)
    sendEvent({
      eventName: 'CTA',
      data: {
        LABEL: children,
        DESCRIPTION: 'Transbordo para WhatsApp',
        ACTION: 'Transbordo para WhatsApp',
        TYPE: 'button'
      }
    })

    window.location.href = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${message}&type=phone_number&app_absent=0`
  }

  return (
    <CuraButton
      style={style}
      color="whatsapp"
      iconName="whatsapp"
      iconPosition="right"
      size="medium"
      onClick={handleOnClick}
    >
      {children}
    </CuraButton>
  )
}
